import { partySchema } from '../../common';
import { z } from 'zod';

/**
 * `SavedLocation.client` snapshot — the `Client` the saved location
 * belongs to (absent on `isOwnBranch` locations). Pure {@link partySchema};
 * the legacy `customerType` projection was retired as part of the
 * customer→client cutover (see migration
 * `<ts>-relations-v2-saved-location.ts`).
 *
 * Display layers that previously branched on `customerType` should
 * read `roles[0]` from this snapshot instead.
 */
export const savedLocationClientSchema = partySchema;
export type SavedLocationClient = z.infer<typeof savedLocationClientSchema>;
